import DatePicker from "legacy/DatePicker"
import PricingStructureSelect from "legacy/PricingStructureSelect"
import { snakeCaseToReadable } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class CustomizeBillingForm extends React.Component {
  showMonthlyCustomBilling() {
    return (
      this.props.billingCycle === "first_of_month" &&
      this.props.hasCustomInstallmentFeature
    )
  }

  halfAndHalf() {
    return this.props.billingCycle === "half_and_half"
  }

  upFront() {
    return this.props.billingCycle === "upfront"
  }

  billingDateSection() {
    if (this.props.customBillingPeriod && this.upFront()) {
      return (
        <div className="form-group bs-mt-3">
          <label>Billing Date</label>
          <div className="form-control-with-icon">
            <i className="fa-kit fa-calendar form-control-icon-left" />
            <DatePicker
              setParentState={(date) =>
                this.props.setBillingDateState(date, "billingStartDate")
              }
              value={
                this.props.billingStartDate &&
                moment(this.props.billingStartDate).format("L")
              }
              disabled={this.props.editMode || false}
            />
          </div>
        </div>
      )
    } else if (
      this.props.customBillingPeriod &&
      (this.showMonthlyCustomBilling() || this.halfAndHalf())
    ) {
      return (
        <div className="row form-row bs-mt-3">
          <div className="col-sm-6">
            <div className="form-group">
              <label>
                {this.halfAndHalf() ? "50% Deposit Date" : "Billing Start Date"}
              </label>
              <div className="form-control-with-icon">
                <i className="fa-kit fa-calendar form-control-icon-left" />
                <DatePicker
                  setParentState={(date) =>
                    this.props.setBillingDateState(date, "billingStartDate")
                  }
                  value={
                    this.props.billingStartDate &&
                    moment(this.props.billingStartDate).format("L")
                  }
                  disabled={this.props.editMode || false}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label>
                {this.halfAndHalf() ? "Remaining 50% Date" : "Billing End Date"}
              </label>
              <div className="form-control-with-icon">
                <i className="fa-kit fa-calendar form-control-icon-left" />
                <DatePicker
                  setParentState={(date) =>
                    this.props.setBillingDateState(date, "billingEndDate")
                  }
                  value={
                    this.props.billingEndDate &&
                    moment(this.props.billingEndDate).format("L")
                  }
                  startDate={moment(this.props.billingStartDate).format("L")}
                  disabled={this.props.editMode || false}
                />
              </div>
            </div>
          </div>
        </div>
      )
    }
    return null
  }

  directPaymentSection() {
    if (!this.props.hideDirectPaymentOption) {
      return (
        <div className="checkbox bs-mb-3">
          <label>
            <input
              type="checkbox"
              checked={
                !this.props.hideDirectPaymentOption &&
                this.props.allowDirectPayment
              }
              name="allowDirectPayment"
              onChange={this.props.handleInputChange}
            />
            Allow boaters the option to pay direct (cash, check, ACH)
          </label>
        </div>
      )
    }
    return null
  }

  customBillingPeriodSection() {
    if (
      this.showMonthlyCustomBilling() ||
      this.upFront() ||
      this.halfAndHalf()
    ) {
      return (
        <div className="checkbox bs-mb-0">
          <label>
            <input
              type="checkbox"
              checked={this.props.customBillingPeriod}
              name="customBillingPeriod"
              onChange={
                this.props.handleCustomBillingInputChange ||
                this.props.handleInputChange
              }
              disabled={this.props.editMode}
            />
            Custom Billing Period
          </label>
        </div>
      )
    }
    return null
  }

  render() {
    return (
      <div className="customize-billing-form-controller">
        <div className="row">
          <div className="col-sm-3">
            <h4>Billing</h4>
          </div>
          <div className="col-sm-9">
            <div className="row form-row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label>Rate</label>
                  <div className="form-control-with-icon">
                    <i className="fa-kit fa-cash form-control-icon-left" />
                    <input
                      className="form-control"
                      type="text"
                      name="rate"
                      required="required"
                      value={this.props.rate > 0 ? this.props.rate : ""}
                      onChange={this.props.handleInputChange}
                      disabled={this.props.editMode}
                    />
                  </div>
                  {this.props.validator.message(
                    "rate",
                    this.props.rate,
                    "required"
                  )}
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label>Tax Rate</label>
                  <div className="form-control-with-icon">
                    <i className="fa-kit fa-percent form-control-icon-right" />
                    <input
                      className="form-control"
                      type="text"
                      name="taxRate"
                      required="required"
                      value={this.props.taxRate}
                      onChange={this.props.handleInputChange}
                      disabled={this.props.editMode}
                    />
                  </div>
                  {this.props.validator.message(
                    "tax_rate",
                    this.props.taxRate,
                    "required"
                  )}
                </div>
              </div>
            </div>
            <div className="row form-row">
              <div className="col-sm-6">
                <PricingStructureSelect
                  pricingStructure={this.props.pricingStructure}
                  pricingStructures={this.props.pricingStructures}
                  handleInputChange={this.props.handleInputChange}
                  disabled={this.props.editMode}
                />
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label>Billing Cycle</label>
                  <select
                    className="form-control"
                    name="billingCycle"
                    value={
                      this.props.billingCycle || this.props.billingCycles[0]
                    }
                    onChange={this.props.handleInputChange}
                    disabled={
                      this.props.editMode ||
                      this.props.billingCycles.length === 1
                    }
                  >
                    {this.props.billingCycles.map((billing) => (
                      <option key={billing} value={billing}>
                        {snakeCaseToReadable(billing)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            {this.directPaymentSection()}
            {this.customBillingPeriodSection()}
            {this.billingDateSection()}
          </div>
        </div>
      </div>
    )
  }
}

CustomizeBillingForm.propTypes = {
  billingCycle: PropTypes.string,
  billingCycles: PropTypes.array.isRequired,
  hasCustomInstallmentFeature: PropTypes.bool,
  customBillingPeriod: PropTypes.bool,
  billingStartDate: PropTypes.string,
  billingEndDate: PropTypes.string,
  hideDirectPaymentOption: PropTypes.bool,
  allowDirectPayment: PropTypes.bool,
  editMode: PropTypes.bool,
  rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  taxRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pricingStructure: PropTypes.string,
  pricingStructures: PropTypes.object.isRequired,
  validator: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleCustomBillingInputChange: PropTypes.func,
  setBillingDateState: PropTypes.func.isRequired,
}

CustomizeBillingForm.defaultProps = {
  billingCycles: [],
}

export default CustomizeBillingForm
